import { Component, NgZone, OnInit, ViewEncapsulation, PLATFORM_ID, DestroyRef, inject } from '@angular/core';
import { distinctUntilChanged, take } from 'rxjs/operators';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { CookieConsentService } from '@services/cookie-consent.service';
import { DatePipe, isPlatformBrowser } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`,
  styleUrls: ['./app.component.scss'],
  providers: [DatePipe],
  encapsulation: ViewEncapsulation.None,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly authService = inject(AuthService);
  private readonly ccService = inject(CookieConsentService);
  private readonly toast = inject(ToastrService);
  private readonly ngZone = inject(NgZone);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly isBrowser = isPlatformBrowser(this.platformId);

  ngOnInit() {
    if (this.isBrowser) {
      // Handle PPT token authentication
      this.route.queryParams
        .pipe(distinctUntilChanged(), take(1), takeUntilDestroyed(this.destroyRef))
        .subscribe(params => {
          const token: string = params?.ppt_token;
          if (token && !this.authService.isLoggedIn) {
            // Verify PPT token if provided and user is not logged in
            this.authService
              .verifyToken(token)
              .pipe(take(1), takeUntilDestroyed(this.destroyRef))
              .subscribe(() => {
                this.router.navigate(['/']).then(() => {
                  this.toast.success("L'utente ha effettuato l'accesso");
                });
              });
          }
        });

      // Load cookie consent outside Angular zone
      this.ngZone.runOutsideAngular(() => {
        this.ccService.loadConfig();
      });

      // Token validation timer for logged-in users
      if (isPlatformBrowser(this.platformId) && this.authService.isLoggedIn) {
        const REFRESH_TIMER = 30 * 60 * 1000; // 30 minutes
        this.authService.validateTokenTimer(REFRESH_TIMER).pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
      }
    }
  }
}
